import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Region } from '../../types/organization/region';
import { UntypedFormGroup } from '@angular/forms';
import { RegionRestService } from '../../services/region/region-rest.service';
import { RegionDirectoryRestService } from '../../services/region/region-directory-rest.services';
import { SystemType } from '../../types/common/system-type';

@Component({
  selector: 'wsd-select-region',
  templateUrl: './select-region.component.html',
  styleUrls: ['./select-region.component.css']
})
export class SelectRegionComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  isDisabled: boolean = false;

  @Input()
  isNew: boolean = false;

  @Input()
  label: string = 'SELECT_REGION.LABEL';

  @Input()
  controlName: string = 'region';

  @Input()
  showLabel: boolean = true;

  @Input()
  initialRegionId: number;

  @Output()
  private onChange = new EventEmitter<void>();

  regionItems: SelectItem[] = [];

  constructor(private regionService: RegionRestService,
    private regionDirService: RegionDirectoryRestService) { }

  ngOnInit() {
    this.loadRegions();
    if (this.isDisabled) {
      this.parentForm.get(this.controlName).disable();
    }
  }

  private loadRegions() {
    if (this.isNew) {
      this.regionDirService.getIdmRegions().subscribe(
        (regions: Region[]) => {
          this.fillRegions(regions);
          this.setInitialRegion();
        }
      );
    } else {
      this.regionService.getAllRegions(SystemType.DIRECTORY).subscribe(
        (regions: Region[]) => {
          this.fillRegions(regions);
          this.setInitialRegion();
        }
      );
    }

  }

  private fillRegions(regions: Region[]) {
    this.regionItems = regions.map(value => {
      return {
        label: value.name,
        value
      };
    });
  }

  private setInitialRegion() {
    if (!this.initialRegionId) {
      return;
    }
    for (const item of this.regionItems) {
      if (item.value && item.value.id === this.initialRegionId) {
        this.parentForm.get('region').setValue(item.value);
        return;
      }
    }
  }

  change(event) {
    this.onChange.emit();
  }

}
